<template>
  <section>
    <div class="activeFilters">
      <ul class="activeFilters__labels">
        <li
          class="activeFilters__labelItem"
          v-if="selectedBrand"
          @click="resetBrand()"
        >
          {{ $t("filters.brand") }}: {{ selectedBrand }}
        </li>

        <li
          class="activeFilters__labelItem"
          v-if="selectedModel"
          @click="resetModel()"
        >
          {{ $t("filters.model") }}:
          {{
            generalSettings.mergeModels
              ? selectedModel.split(" ")[0]
              : selectedModel
          }}
        </li>

        <li
          class="activeFilters__labelItem"
          v-if="isCarselexy"
          @click="resetCarSelexy()"
        >
          CarSelexy
        </li>

        <li
          class="activeFilters__labelItem"
          v-for="option in checkedFilters"
          v-bind:key="option.id"
          @click="disableOption(option.parentCat.id, option.id)"
        >
          {{ $t("vehicle." + option.parentCat.id) }}: {{ option.label }}
        </li>

        <button
          class="activeFilters__labelItem activeFilters__labelItem--reset"
          v-if="numberFilters > 1"
          @click="resetFilters"
        >
          {{ $t("filters.resetFilters") }}
        </button>
      </ul>
      <!-- .activeFilters__labels -->
      <span v-if="vehicles.length > 0" class="activeFilters__resultCount">{{
        $tc("filters.results", vehicles.length)
      }}</span>
    </div>
    <!-- .activeFilters -->

    <div class="vehicleGrid" :class="'-view-' + viewMode">
      <div
        class="vehicleGrid__item"
        v-for="vehicle in vehicles"
        v-bind:key="vehicle.id"
      >
        <Vehicle :vehicle="vehicle"></Vehicle>
      </div>
      <!-- .vehicleGrid__item -->
    </div>
    <!-- .vehicleGrid -->

    <div class="noVehicles" v-if="vehicles.length === 0">
      <h2 class="noVehicles__title">{{ $t("filters.emptyState.title") }}</h2>
      <p class="noVehicles__text">{{ $t("filters.emptyState.desc") }}</p>
      <button
        class="button button--secondary noVehicles__resetButton"
        @click="resetFilters"
      >
        {{ $t("filters.emptyState.button") }}
      </button>
    </div>
  </section>
</template>

<script>
import Vehicle from "@/components/Vehicle";

export default {
  name: "results",
  components: {
    Vehicle,
  },
  data() {
    return {
      generalSettings: this.$store.state.settings.general,
    };
  },
  computed: {
    checkedFilters: function () {
      return this.$store.getters["filters/checkedLabels"];
    },
    vehicles: function () {
      return this.$store.getters["vehicles/filtered"];
    },
    viewMode: function () {
      return this.$store.state.vehicles.viewMode;
    },
    selectedBrand: function () {
      return this.$store.state.filters.selectedBrand;
    },
    selectedModel: function () {
      return this.$store.state.filters.selectedModel;
    },
    isCarselexy: function () {
      return this.$store.state.filters.isCarselexy;
    },
    numberFilters: function () {
      let counter = 0;

      if (this.selectedBrand) {
        counter++;
      }

      if (this.selectedModel) {
        counter++;
      }

      counter += this.checkedFilters.length;
      return counter;
    },
  },
  methods: {
    disableOption(catId, optionId) {
      this.$store.commit("filters/updateOption", {
        catId: catId,
        optionId: optionId,
        checked: false,
      });
    },
    resetFilters() {
      this.$store.commit("filters/resetAll");
      this.$store.commit("search/update", "");
    },
    resetBrand() {
      this.$store.commit("filters/updateBrand", "");
    },
    resetModel() {
      this.$store.commit("filters/updateModel", "");
    },
    resetCarSelexy() {
      this.$store.commit("filters/updateCarSelexy", false);
    },
  },
};
</script>
